<template>
<div class="dashboard-widget-tabs p-0">
	<div class="dashboard-widget-tabs-content mb-0" style="padding: 15px !important;">
		<h2>
			<i class="uil uil-create-dashboard"></i> داشبورد‌ها
		</h2>
		<div class="dashboard-widget-h-btns">
			<a href="" class="m-left m-top tgju-btn tgju-btn-primary" @click.prevent="open_dashboard_add_modal()" v-tooltip="'ایجاد داشبورد جدید'"><i class="uil uil-plus-circle"></i> ایجاد داشبورد</a>
		</div>
	</div>

	<div class="sidebar-box">
		<slot v-if="widgetLoad">
			<div class="tgju-widget-content full-padding">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>		
		</slot>
		<slot v-else>
			<slot v-if="dashboards.length">
				<table class="widget-table widget-table-lg">
					<thead>
						<tr>
							<th>عنوان داشبورد</th>
							<th class="hide-640">زمان ایجاد</th>
							<th class="hide-table-r hide-640">زمان آخرین تغییر</th>
							<th class="w60 text-center">ویرایش</th>
							<th class="w60 text-center">حذف</th>
						</tr>
					</thead>
					<tbody>
						<tr class="pointer" v-for="dashboard in dashboards" :key="dashboard.id"  @click.prevent="goToRoute(dashboard.id)">
							<td class="border-l">{{ dashboard.title }}</td>
							<td class="border-l hide-640">{{ toRelative(dashboard.created_at) }}</td>
							<td class="border-l hide-table-r hide-640">{{ toRelative(dashboard.updated_at) }}</td>
							<td class="w60 text-center border-l"><i class="uil uil-edit-alt table-icons pointer" v-tooltip="'ویرایش'" @click.stop="goToRoute(dashboard.id)"></i></td>
							<td class="w60 text-center"><i class="uil uil-trash table-icons red-color pointer" v-tooltip="'حذف'" @click.stop="removeDashboard(dashboard.id)"></i></td>
						</tr>
					</tbody>
				</table> 
			</slot>
			<div v-if="!dashboards.length" class="popup-dash-empty">
				<div class="noWidget noContent">
					<div>
						<i class="uil uil-layer-group-slash noContent-icon" aria-hidden="true"></i>
						<p class="noContent-title">در حال حاضر هیچ داشبوردی برای نمایش وجود ندارد!</p>
						<p class="noContent-description">
							شما میتوانید براحتی از منوی بالا و دکمه ایجاد ، داشبورد خورد را ایجاد نمایید
						</p>
					</div>
				</div>
			</div>
		</slot>
	</div>
</div>
</template>


<script>
	// این ویو برای لیست داشبوردها استفاده میشود
	import moment from "moment-jalaali";

	export default {
		name: 'DashboardList',
		components: {},
		data: function () {
			return {
				dashboards: [],
				dashboard: {
					id: null,
					user_id: null,
					title: '',
					type: null,
					default: false,
					created_at: null,
					updated_at: null,
				},
				loading: true,
			}
		},

		mounted() {
			// لود کردن لیست داشبورد های کاربر
			this.loadDashboards();
		},

		methods: {
			// این متد جهت نمایش مناسب زمان مورد استفاده قرار میگیرد
			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},
			// این متد جهت واکشیه داشبورد ها از استور ویو جی اس استفاده میشود
			loadDashboards() {

				let dashboards = this.$store.state.dashboards;
				if (dashboards.length) {
					this.loading = false;
				}
				if (dashboards.length <= 0) {
					this.loading = false;
				}
				this.dashboards = dashboards;
			},
			// این متد جهت حذف داشبورد استفاده میشود
			removeDashboard(id) {
				this.$helpers.confirm('هشدار حذف!', {
					message: 'آیا از حذف این داشبورد اطمینان دارید؟',
				}).then((confirmed) => {
					if ( confirmed ) {
						this.$helpers.makeRequest('DELETE', '/dashboard/delete/' + id).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.status == 200 ) {
								this.$store.commit('removeDashboard', {id: id});
								this.$swal.fire({
									icon:"success",
									title:"داشبورد با موفقیت حذف شد",
									showConfirmButton:!1,
									timer:2000
								});
							}else{
								this.$swal.fire({
									icon:"error",
									title:"مشکلی در حذف داشبورد رخ داده است",
									showConfirmButton:!1,
									timer:2000
								});
							}
						});	
					}
				});
			},
			// از این متد جهت تغییر روت کنونی به حالت ویرایش داشبورد انتخاب شده استفاده میشود
			goToRoute(id) {
				this.$router.push({ name: "DashboardEdit", params: {id}});
			},
			// از این متد برای باز کردن مودال افوزدن داشبورد جدید و هندل کردن درخواست استفاده میشود
			open_dashboard_add_modal() {
				let callbackEvent = this.$router.currentRoute.name + '_manageDashboards_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'DashboardAdd.vue',
					config: {
						title: 'افزودن داشبورد',
						icon: 'uil uil-plus-circle with-icon',
						smallModal: true,
						data: {
							dashboards: this.dashboards
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					if ( response.action == 'addDashboard' ) {
						this.$store.commit('addDashboard', {dashboard: response.data.dashboard});
					}
				});
			},

		}
	}
</script>